<div class="page-container">
  <div class="page-heading">
    <h3>
      <img class="nav-icon" src="assets/icons/route_planner.svg">
      <span class="page-title">{{ 'sideNavigation.titleRoutePlanning' | translate }}</span>
    </h3>
    <div class="actions">
      @if (activeAction === actions.NONE) {
        <button
          (click)="enableCreateBase()"
          class="btn btn-primary">
          <img class="action-icon" src="assets/icons/add_white_24dp.svg">
          {{ 'planner.routePlanning.createBase' | translate }}
        </button>
      }
      @if (activeAction === actions.CREATE_BASE) {
        <form [formGroup]="form">
          <span class="action-help-text me-2">
            {{ 'planner.routePlanning.clickToCreateBase' | translate }}
          </span>
          <button (click)="cancelAction()"
            class="btn btn-secondary">
            {{ 'basic.cancel' | translate }}
          </button>
          <div class="base-form">
            <input id="baseIdentifier"
              type="text"
              class="form-control"
              formControlName="baseIdentifier"
              [placeholder]="'planner.routePlanning.baseIdentifier' | translate" />
          </div>
        </form>
      }

      @if (activeAction === actions.NONE) {
        <button
          (click)="enableDrawRoute()"
          class="btn btn-primary">
          <img class="action-icon" src="assets/icons/edit_white_24dp.svg">
          {{ 'planner.routePlanning.drawRoute' | translate }}
        </button>
      }

      @if (activeAction === actions.DRAW_ROUTE) {
        <form [formGroup]="form">
          <span class="action-help-text me-2">
            {{ 'planner.routePlanning.enterToSaveRoute' | translate }}
          </span>
          <button (click)="cancelAction()"
            class="btn btn-secondary">
            {{ 'basic.cancel' | translate }}
          </button>
          <div class="route-form">
            <input id="routeIdentifier"
              type="text"
              class="form-control"
              formControlName="routeIdentifier"
              [placeholder]="'planner.routePlanning.routeIdentifier' | translate" />
          </div>
        </form>
        <div class="draw-route-settings">
          <label>{{ 'planner.routePlanning.routeColor' | translate }}:</label>
          <input
            id="colorPicker"
            type="color"
            [(ngModel)]="selectedRouteColor"
            />
          <div class="input-wrapper">
            <input
              id="colorPickerResult"
              type="text"
              maxlength="7"
              class="color-input"
              autocomplete="off"
              [(ngModel)]="selectedRouteColor"
              (ngModelChange)="onColorTextChange($event)"
              />
            @if (selectedRouteColor !== defaultRouteColor || selectedRouteColorError) {
              <button
                type="button"
                class="clear-btn"
                (click)="resetRouteColor()">
                ×
              </button>
            }
          </div>
          @if (selectedRouteColorError) {
            <span class="text-danger">{{ selectedRouteColorError }}</span>
          }
        </div>
      }
    </div>
    <div class="tools-info">
      <span class="info"><img class="base-icon pe-1" src="assets/icons/powerlines/base.png">
        {{ 'planner.routePlanning.base' | translate }}
      </span>
      <span class="info"><span class="lines pe-1">---</span>
      {{ 'planner.routePlanning.route' | translate }}
    </span>
  </div>
</div>
<div class="page-content">
  <div class="map-height map-container">
    <div id="mapProject"></div>
  </div>
</div>
</div>
@if (showSidebar) {
  <div class="rightsidebar">
    <div class="sidebarcontent">
      <img (click)="closeSidebar()" src="assets/icons/close_red_24dp.svg" class="close-btn" />
      <h2>
        @if (selectedItem?.type === 'BASE') {
          {{ 'Base' }} #{{ selectedItem?.item?.id }}
        }
        @if (selectedItem?.type === 'ROUTE') {
          {{ 'Route' }} #{{ selectedItem?.item?.id }}
        }
      </h2>
      @if (selectedItem?.type === 'ROUTE' && selectedRouteLength) {
        <div class="route-length-info mb-3">
          <strong>{{ 'planner.routePlanning.routeLength' | translate }}:</strong> {{ selectedRouteLength }}
        </div>
      }
      <div>
        <form [formGroup]="selectedItemForm">
          <div>Identifier</div>
          <div>
            <input type="identifier" id="identifier" formControlName="identifier" />
          </div>
        </form>
        @if (selectedItem?.type === 'ROUTE') {
          <div class="mt-3">Color</div>
          <div class="draw-route-settings">
            <input
              id="colorPicker2"
              type="color"
              [(ngModel)]="selectedItemColor"
              />
            <div class="input-wrapper">
              <input
                id="colorPickerResult2"
                type="text"
                maxlength="7"
                class="color-input"
                autocomplete="off"
                [(ngModel)]="selectedItemColor"
                (ngModelChange)="onColorTextChange($event)"
                />
              @if (selectedItemColor !== defaultRouteColor || selectedItemColorError) {
                <button
                  type="button"
                  class="clear-btn me-2"
                  (click)="resetRouteColor()">
                  ×
                </button>
              }
            </div>
            @if (selectedItemColorError) {
              <span class="text-danger">{{ selectedItemColorError }}</span>
            }
          </div>
        }
      </div>
      <div class="buttons pt-4">
            <button (click)="selectedItem?.type === 'BASE'
                        ? deleteBase(selectedItem?.item?.id)
                        : deleteRoute(selectedItem?.item?.id)"
          class="btn btn-danger mr-1">
          {{ 'basic.delete' | translate }}
        </button>
            <button (click)="selectedItem?.type === 'BASE'
                        ? updateSelectedBase()
                        : updateSelectedRoute()"
          [disabled]="!!selectedItemColorError" class="btn btn-primary mr-0">
          {{ 'basic.save' | translate }}
        </button>
      </div>
      <hr>
        @if (selectedItem?.type === 'ROUTE') {
          <div class="buttons pt-4">
            <button (click)="openCreateRouteNoteFromSidebar()"
              class="btn btn-primary mb-3 w-100">
              {{ 'planner.routePlanning.createRouteNote' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Route Note Modal -->
  <div #routeNotesModal class="modal fade" id="routeNotesModal" tabindex="-1"
    aria-labelledby="routeNotesModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="routeNotesModalLabel">
            @if (routeNoteMode === 'CREATE') {
              {{'planner.routePlanning.createNewRouteNote' | translate }}
            }
            @if (routeNoteMode === 'EDIT' || routeNoteMode === 'DELETE') {
              {{'planner.routePlanning.editRouteNote' | translate }}
            }
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          @if (routeNoteMode === 'CREATE') {
            <textarea
              id="createRouteNoteText"
              class="form-control"
              rows="5"
              [(ngModel)]="routeNoteText"
              placeholder=""
            ></textarea>
          }
          @if (routeNoteMode === 'EDIT' || routeNoteMode === 'DELETE') {
            <textarea
              id="editRouteNoteText"
              class="form-control"
              rows="5"
              [(ngModel)]="routeNoteText"
              placeholder=""
            ></textarea>
          }
        </div>

        <div class="modal-footer">
          @if (routeNoteMode !== 'DELETE') {
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              {{'basic.close' | translate }}
            </button>
          }
          @if (routeNoteMode === 'CREATE') {
            <button (click)="createRouteNote()" type="button" class="btn btn-primary">
              {{'basic.add' | translate }}
            </button>
          }
          @if (routeNoteMode === 'EDIT') {
            <button (click)="deleteRouteNote()" type="button" class="btn btn-danger">
              {{'basic.delete' | translate }}
            </button>
          }
          @if (routeNoteMode === 'EDIT') {
            <button (click)="editRouteNote()" type="button" class="btn btn-primary">
              {{'basic.save' | translate }}
            </button>
          }
          @if (routeNoteMode === 'DELETE') {
            <button (click)="dismissDeleteRouteNote()" type="button" class="btn btn-secondary">
              {{'basic.back' | translate }}
            </button>
          }
          @if (routeNoteMode === 'DELETE') {
            <button (click)="confirmDeleteRouteNote()" type="button" class="btn btn-danger">
              {{'basic.confirmDelete' | translate }}
            </button>
          }
        </div>

      </div>
    </div>
  </div>
